import * as stylex from '@stylexjs/stylex'

import { colors, fontSizes, layers, radii, spacing } from '../tokens/tokens.stylex'

export const overlayStyles = stylex.create({
  trigger: {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderWidth: 0,
    color: colors.foreground,
    cursor: { default: 'pointer', ':disabled': 'not-allowed' },
    display: 'inline-flex',
    fontSize: fontSizes.label,
    gap: spacing.space8,
    opacity: { default: 1, ':disabled': 0.5 },
    outline: { default: 'none', ':focus-visible': `2px solid ${colors.foreground}` },
    outlineOffset: 3,
    padding: 0,
    textAlign: 'start',
  },
  row: {
    backgroundColor: { default: 'transparent', ':hover': colors.hover },
    borderRadius: radii.small,
    minHeight: 40,
    padding: spacing.space8,
    width: '100%',
  },
  positioner: { zIndex: layers.popup },
  popup: {
    backgroundColor: colors.background,
    borderColor: colors.border,
    borderRadius: radii.small,
    borderStyle: 'solid',
    borderWidth: 1,
    boxSizing: 'border-box',
    color: colors.foreground,
    fontSize: fontSizes.label,
    maxHeight: 'var(--available-height)',
    maxWidth: 'calc(100vw - 16px)',
    outline: 'none',
    overflowY: 'auto',
    padding: spacing.space8,
    width: 280,
  },
  compact: { width: 240 },
  sheet: { borderRadius: 0, borderInlineWidth: 0, maxHeight: 'calc(100dvh - 64px)', maxWidth: '100%', width: '100%' },
})
